/**
 * How a reply arrives on screen. The backend answers whole, not as a token
 * stream, so a client shows the typing dots while the request is out and
 * then reveals the reply's paragraphs one bubble at a time, dots between,
 * the way a person sends successive messages. The cadence is the embed
 * contract's, not one client's: the dashboard console and the widget on a
 * customer's page must feel the same, and the numbers here are `main`'s
 * widget, kept.
 */
export const REPLY_REVEAL = {
  /** Dots after the reply is in hand, before its first paragraph shows. */
  holdMs: 1260,
  /** Dots between one paragraph and the next. */
  gapMs: 1520,
  /** Spread on the gap, so a long reply does not tick like a clock. */
  jitterMs: 100,
} as const

/**
 * When each of `count` paragraphs shows, in ms after the reply arrived -
 * cumulative, so a client sets every timer at once. The first is the hold;
 * each next is a gap after the last, nudged by the jitter. `random` is
 * injectable for a test that wants the schedule exact.
 */
export function revealTimes(
  count: number,
  random: () => number = Math.random
): number[] {
  const times: number[] = []
  let at = 0
  for (let index = 0; index < count; index++) {
    if (index === 0) {
      at += REPLY_REVEAL.holdMs
    } else {
      const jitter = Math.round((random() * 2 - 1) * REPLY_REVEAL.jitterMs)
      at += Math.max(0, REPLY_REVEAL.gapMs + jitter)
    }
    times.push(at)
  }
  return times
}
